//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicasLinares } from "@/typings/store/plugins/easyFirestore/cajaChicasLinares";

const getters: GetterTree<StateCajaChicasLinares, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const cajaChicasLinares = {
    firestorePath: "dev/v1/cajaChicasLinares",
    firestoreRefType: "collection",
    moduleName: "cajaChicasLinares",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default cajaChicasLinares;
